import {
  DocumentRegisterSignerSignOrderFragment,
  SignerSignOrderFragment,
  SignPathSignOrderFragment,
} from "gql/graphql";
import { useTranslations } from "use-intl";

/**
 * Номер очереди подписи для человека: с бэкенда очередь приходит с нуля (пусто = 0),
 * а показываем с единицы — «Очередь 1», «Очередь 2». Меньший подписывает раньше, одинаковые — одновременно.
 */
export function SignOrderLabel({
  data,
}: {
  data:
    | SignerSignOrderFragment
    | DocumentRegisterSignerSignOrderFragment
    | SignPathSignOrderFragment;
}) {
  const t = useTranslations("SignSignature");

  return <>{t("Sign order", { order: (data.order ?? 0) + 1 })}</>;
}
